import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/getInstantQuote.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/SliderHydrator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/TestimonialSectionHydrator.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/paw-prints-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/zig-zag.png");
